import Layout from "@/views/layout";

const userRouter = {
  path: "/user",
  name: "User",
  component: Layout,
  meta: { title: "用户模块" },
  children: [
    {
      path: "password",
      name: "Password",
      component: () => import("@/views/user/password"),
      meta: { title: "修改密码" }
    },
    {
      path: "accountSetting",
      name: "AccountSetting",
      component: () => import("@/views/user/accountSetting"),
      meta: { title: "设置" }
    }
  ]
};

export default userRouter;
